
import {
  ALL_PRODUCT_FAIL,
  ALL_PRODUCT_REQUEST,
  ALL_PRODUCT_REQUEST_CATEGORY,
  ALL_PRODUCT_SUCCESS,
  ADMIN_PRODUCT_REQUEST,
  ADMIN_PRODUCT_SUCCESS,
  ADMIN_PRODUCT_FAIL,
  NEW_PRODUCT_REQUEST,
  NEW_PRODUCT_SUCCESS,
  NEW_PRODUCT_FAIL,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAIL,
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAIL,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_FAIL,
  PRODUCT_DETAILS_SUCCESS,
  NEW_REVIEW_REQUEST,
  NEW_REVIEW_SUCCESS,
  NEW_REVIEW_FAIL,
  ALL_REVIEW_REQUEST,
  ALL_REVIEW_SUCCESS,
  ALL_REVIEW_FAIL,
  DELETE_REVIEW_REQUEST,
  DELETE_REVIEW_SUCCESS,
  DELETE_REVIEW_FAIL,
  // DELETE_REVIEW_RESET,
  CLEAR_ERRORS,
} from "../constants/productConstant";

import http from '../interceptor/httpservice'

// Get All Products
export const getProduct =
  (keyword = "", currentPage = 1, price = [0, 25000], category, subcategory, gender, ratings = 0, accessoryGroup = false, saleOnly = false, sort = "recommended", sizes = [], sizeInStock = true) =>
  async (dispatch) => {
    try {
      dispatch({ type: ALL_PRODUCT_REQUEST });

      // Always include page parameter for pagination
      let link = `/api/v1/products?keyword=${keyword}&page=${currentPage}`;

      if (category) {
        // When category is selected, just add category filter (don't include price filters which break the nested price structure)
        // Don't URL encode - let the http library handle it, or encode only spaces/special chars
        const categoryParam = category.replace(/\s+/g, ' ').trim(); // Normalize spaces
        link = `/api/v1/products?keyword=${keyword}&page=${currentPage}&category=${encodeURIComponent(categoryParam)}`;
      }

      if (subcategory) {
        link += `&subcategory=${encodeURIComponent(subcategory)}`;
      }

      if (gender) {
        link += `&gender=${encodeURIComponent(gender)}`;
      }

      if (accessoryGroup) {
        link += `&accessoryGroup=true`;
      }

      if (saleOnly) {
        link += `&sale=true`;
      }

      if (sort) {
        link += `&sort=${encodeURIComponent(sort)}`;
      }

      if (Array.isArray(sizes) && sizes.length > 0) {
        link += `&sizes=${encodeURIComponent(sizes.join(","))}`;
        if (sizeInStock) {
          link += `&sizeInStock=true`;
        }
      }

      console.log('🔵 [PRODUCT_ACTION] Fetching products with link:', link);
      console.log('🔵 [PRODUCT_ACTION] Category:', category, 'Subcategory:', subcategory, 'Gender:', gender, 'Accessory Group:', accessoryGroup, 'Sale Only:', saleOnly, 'Sort:', sort);

      const { data } = await http.get(link);

      console.log('✅ [PRODUCT_ACTION] Products received:', data?.products?.length || 0, 'products');

      dispatch({
        type: ALL_PRODUCT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.error('❌ [PRODUCT_ACTION] ERROR GET PRODUCT:', error);
      dispatch({
        type: ALL_PRODUCT_FAIL,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Unable to load products.",
      });
    }
  };

  export const getProductCategory =
  (category,gender) =>
  async (dispatch) => {
    try {
      // (keyword = "", currentPage = 1, price = [0, 25000], category, ratings = 0)
      dispatch({ type: ALL_PRODUCT_REQUEST_CATEGORY });
      console.log("product Action ---->",category,gender);

      let link = `/api/v1/products/category?cat=${category}&gender=${gender}`;

      // let link = `/api/v1/products?keyword=${keyword}&page=${currentPage}&price[gte]=${price[0]}&price[lte]=${price[1]}&ratings[gte]=${ratings}`;

      // if (category) {
      //   link = `/api/v1/products?keyword=${keyword}&page=${currentPage}&price[gte]=${price[0]}&price[lte]=${price[1]}&category=${category}&ratings[gte]=${ratings}`;
      // }

      const { data } = await http.get(link);

      dispatch({
        type: ALL_PRODUCT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      // dispatch({
      //   type: ALL_PRODUCT_FAIL,
      //   payload: error.response.data.message,
      // });
      console.log('ERROR GET PRODUCT',error)
    }
  };

// Get All Products For Admin
export const getAdminProduct = () => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_PRODUCT_REQUEST });

    const { data } = await http.get("/api/v1/admin/products");

    dispatch({
      type: ADMIN_PRODUCT_SUCCESS,
      payload: data.products,
    });
  } catch (error) {
    dispatch({
      type: ADMIN_PRODUCT_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Create Product
export const createProduct = (productData) => async (dispatch) => {
  try {
    dispatch({ type: NEW_PRODUCT_REQUEST });

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    const { data } = await http.post(
      `/api/v1/admin/product/new`,
      productData,
      config
    );

    dispatch({
      type: NEW_PRODUCT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: NEW_PRODUCT_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Update Product
export const updateProduct = (id, productData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PRODUCT_REQUEST });

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    const { data } = await http.put(
      `/api/v1/admin/product/${id}`,
      productData,
      config
    );

    dispatch({
      type: UPDATE_PRODUCT_SUCCESS,
      payload: data.success,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_PRODUCT_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Delete Product
export const deleteProduct = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_PRODUCT_REQUEST });

    const { data } = await http.delete(`/api/v1/admin/product/${id}`);

    dispatch({
      type: DELETE_PRODUCT_SUCCESS,
      payload: data.success,
    });
  } catch (error) {
    dispatch({
      type: DELETE_PRODUCT_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Get Products Details
export const getProductDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_DETAILS_REQUEST });

    const { data } = await http.get(`/api/v1/product/${id}`);
    await console.log('Product Data--->', data)
    dispatch({
      type: PRODUCT_DETAILS_SUCCESS,
      payload: data.product,
    });
  } catch (error) {
    dispatch({
      type: PRODUCT_DETAILS_FAIL,
      payload: error.response.data.message,
    });
  }
};

// NEW REVIEW
export const newReview = (reviewData) => async (dispatch) => {
  try {
    dispatch({ type: NEW_REVIEW_REQUEST });

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    const { data } = await http.put(`/api/v1/review`, reviewData, config);

    dispatch({
      type: NEW_REVIEW_SUCCESS,
      payload: data.success,
    });
  } catch (error) {
    dispatch({
      type: NEW_REVIEW_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Get All Reviews of a Product
export const getAllReviews = (id) => async (dispatch) => {
  try {
    dispatch({ type: ALL_REVIEW_REQUEST });

    const { data } = await http.get(`/api/v1/reviews?id=${id}`);

    dispatch({
      type: ALL_REVIEW_SUCCESS,
      payload: data.reviews,
    });
  } catch (error) {
    dispatch({
      type: ALL_REVIEW_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Delete Review of a Product
export const deleteReviews = (reviewId, productId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_REVIEW_REQUEST });

    const { data } = await http.delete(
      `/api/v1/reviews?id=${reviewId}&productId=${productId}`
    );

    dispatch({
      type: DELETE_REVIEW_SUCCESS,
      payload: data.success,
    });
  } catch (error) {
    dispatch({
      type: DELETE_REVIEW_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
